<template>
  <div class="counselor-contact">
    <div class="counselor-contact__inner">
      <div class="counselor-contact__group">
        <div class="counselor-contact__title">
          <img src="@/assets/contact/official-email.png" alt="" />
          <span>{{ $t("contactBanner.officialContact") }}</span>
        </div>
        <a
          class="counselor-contact__item"
          :href="contactTelegramUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="@/assets/contact/telegram.png" alt="" />
          <span>Telegram</span>
        </a>
        <a
          class="counselor-contact__item"
          :href="contactWhatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="@/assets/contact/whatsapp.png" alt="" />
          <span>WhatsApp</span>
        </a>
      </div>

      <div class="counselor-contact__group">
        <div class="counselor-contact__title">
          <img src="@/assets/contact/official-contact.png" alt="" />
          <span>{{ $t("contactBanner.officialEmail") }}</span>
        </div>
        <a class="counselor-contact__email" href="mailto:contact@trangpt.ai">
          contact@trangpt.ai
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { contactTelegramUrl, contactWhatsappUrl } from "@/config/config";

export default {
  name: "CounselorContact",
  data() {
    return {
      contactTelegramUrl,
      contactWhatsappUrl,
    };
  },
};
</script>

<style lang="less" scoped>
.counselor-contact {
  width: 100%;
  min-height: 160px;
  padding: 24px 16px;
  box-sizing: border-box;
  background-image: url("@/assets/product/counselor.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.counselor-contact__inner {
  width: 100%;
  max-width: 760px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 150px;
  align-items: flex-start;
}

.counselor-contact__title,
.counselor-contact__item {
  display: flex;
  align-items: center;
}

.counselor-contact__title {
  font-size: 24px;
  line-height: 1.25;
  font-weight: 600;
  margin-bottom: 10px;

  img {
    width: 34px;
    height: 34px;
    margin-left: -2px;
    margin-right: 8px;
    flex: 0 0 auto;
  }
}

.counselor-contact__item,
.counselor-contact__email {
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 600;
}

.counselor-contact__item {
  margin-top: 6px;

  img {
    width: 36px;
    height: 36px;
    margin-right: 8px;
    flex: 0 0 auto;
  }
}

.counselor-contact__email {
  display: inline-block;
  margin-top: 6px;
}

@media screen and (max-width: 768px) {
  .counselor-contact {
    min-height: 190px;
    padding: 24px 20px;
  }

  .counselor-contact__inner {
    max-width: 320px;
    grid-template-columns: 1fr;
    row-gap: 20px;
  }

  .counselor-contact__title {
    font-size: 14px;
    margin-bottom: 8px;

    img {
      width: 24px;
      height: 24px;
      margin-left: -4px;
    }
  }

  .counselor-contact__item,
  .counselor-contact__email {
    font-size: 10px;
  }

  .counselor-contact__item img {
    width: 28px;
    height: 28px;
  }
}
</style>
